import axios from '@/services/axios/axios'

export default {
  async isZeitFabrikAlive () {
    const response = await axios.get('/live')
    return response.status === 200
  }
}
